// extracted by mini-css-extract-plugin
export default {"markdownContent":"MarkdownFormat_markdownContent__QEcyy"};